import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../../shared/BaseFragment";
import React from "react";
import {ChartView} from "./ChartView";

export type BaseChartWidgetProps = BaseFragmentProps & {
  type?: "line" | "bar";
}

export type BaseChartWidgetState = BaseFragmentState & {
  xSeries: string[],
  ySeries: number[],
}

export abstract class BaseChartWidget<P extends BaseChartWidgetProps = BaseChartWidgetProps, S extends BaseChartWidgetState = BaseChartWidgetState> extends BaseFragment<P, S> {

  protected renderContainerContent(): React.ReactElement | null {
    if (!this.state.xSeries || !this.state.ySeries) {
      return null;
    }
    const option = {
      xAxis: {
        type: 'category',
        data: this.state.xSeries,
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: this.state.ySeries,
          type: this.props.type || "bar",
        },
      ],
    };
    return <ChartView option={option} style={{width: "100%", height: "100%"}}/>;
  }
}